export default "__VITE_ASSET__BjS0mhAb__"